import { RequestOrgFilters } from "../types/api"
import {
  GOALS_SCORE_RANGE_BY_SUBJECT_SUBPAGE,
  GOALS_SCORE_RANGE_BY_TEST_SUBPAGE
} from "./tables/performance"

export const REQUEST_ORG_FILTERS_MAP: Record<string, keyof RequestOrgFilters> =
  {
    state: "state",
    district: "districtId",
    school: "schoolId",
    teacher: "teacherId",
    class: "classId",
    student: "studentId",
    grade: "grade"
  }

export const EXPORT_SUBPAGE_PATH_MAPPING: Record<
  string,
  Record<string, string>
> = {
  insights: {
    "details-usage": "usage",
    "activity-log": "usage",
    [GOALS_SCORE_RANGE_BY_TEST_SUBPAGE]: "scores-in-range",
    [GOALS_SCORE_RANGE_BY_SUBJECT_SUBPAGE]: "scores-in-range",
    studentQuestions: "student-questions"
  },
  content: {
    "content-library/element": "bell-ringers",
    "content-library/study-hall": "skill-review",
    "content-library/practice-test": "practice-tests",
    "content-library/mastery-lesson": "mastery-lessons",
    "content-library/mastery-curriculum": "mastery-curriculum"
  }
}

export const RANGE_SET_ID_TO_PROGRAM_AND_COURSE_MAPPING: Record<
  string,
  [string, string]
> = {
  // ACT
  "ACT::MATH": ["ACT", "Math"],
  "ACT::ENGLISH": ["ACT", "English"],
  "ACT::READING": ["ACT", "Reading"],
  "ACT::SCIENCE": ["ACT", "Science"],

  // DSAT
  "DSAT::MATH": ["DSAT", "Math"],
  "DSAT::RW": ["DSAT", "Reading and Writing"],

  // FLEOC
  "FLEOC::BIOLOGY": ["FLEOC", "Biology 1"],
  "FLEOC::HISTORY": ["FLEOC", "U.S. History"],
  "FLEOC::ALGEBRA": ["FLEOC", "B.E.S.T. Algebra 1"],
  "FLEOC::GEOMETRY": ["FLEOC", "B.E.S.T. Geometry"],
  "FLEOC::G9_ELAR": ["FLEOC", "Grade 9 ELA Reading"],
  "FLEOC::G10_ELAR": ["FLEOC", "Grade 10 ELA Reading"],

  // LEAP
  "LEAP::CIVICS": ["LEAP", "Civics"],
  "LEAP::BIOLOGY": ["LEAP", "Biology"],
  "LEAP::GEOMETRY": ["LEAP", "Geometry"],
  "LEAP::ALGEBRA_I": ["LEAP", "Algebra I"],
  "LEAP::HISTORY": ["LEAP", "U.S. History"],
  "LEAP::ENGLISH_I": ["LEAP", "English I"],
  "LEAP::ENGLISH_II": ["LEAP", "English II"],

  // MAAP
  "MAAP::BIOLOGY": ["MAAP", "Biology"],
  "MAAP::ALGEBRA_I": ["MAAP", "Algebra I"],
  "MAAP::HISTORY": ["MAAP", "U.S. History"],
  "MAAP::ENGLISH_II": ["MAAP", "English II"],

  // NCEOC
  "NCEOC::BIOLOGY": ["NCEOC", "Biology"],
  "NCEOC::MATH_1": ["NCEOC", "NC Math 1"],
  "NCEOC::MATH_3": ["NCEOC", "NC Math 3"],
  "NCEOC::ENGLISH_II": ["NCEOC", "English II"],

  //TCAP
  "TCAP::BIOLOGY": ["TCAP", "Biology"],
  "TCAP::GEOMETRY": ["TCAP", "Geometry"],
  "TCAP::ALGEBRA_I": ["TCAP", "Algebra I"],
  "TCAP::ALGEBRA_II": ["TCAP", "Algebra II"],
  "TCAP::ENGLISH_I": ["TCAP", "English I"],
  "TCAP::ENGLISH_II": ["TCAP", "English II"],
  "TCAP::HISTORY": ["TCAP", "U.S. History"],

  //TSIA2
  "TSIA2::ELAR": ["TSIA2", "ELAR"],
  "TSIA2::MATH": ["TSIA2", "Mathematics"]
}

export const PROGRAM_AND_COURSE_TO_RANGE_SET_ID_MAPPING = Object.entries(
  RANGE_SET_ID_TO_PROGRAM_AND_COURSE_MAPPING
).reduce(
  (res, [rangeSetId, [program, course]]) => ({
    ...res,
    [`${program}_${course}`]: rangeSetId
  }),
  {}
)
